<template>
  <div class="info-section-4">

    <div class="info-container">
      <product-title
        :is-left=true
        main-title="Fantasy football"/>

      <info-box
        boxTitle="Lorem Ipsum Title"
        boxContent="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
   been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and
   scrambled it to make a type specimen book. "
      />
    </div>

    <div class="asset-container">
      <img class="asset-mockup" src="../assets/mockup-images/fantopy-phones.png" alt="">
    </div>



  </div>
</template>

<script>
import ProductTitle from "../components/productComponents/ProductTitle";
import InfoBox from "../components/productComponents/InfoBox";

export default {
  name: 'InfoSection4',
  components: {InfoBox, ProductTitle},
}
</script>

<style lang="scss">
@import "InfoSection4.scss";
</style>
